import React, { useEffect, useRef, useState } from "react";
import {
  useTranslate,
  IResourceComponentsProps,
  useDelete,
  useNavigation,
  useShow,
  useList,
  useCan,
} from "@pankod/refine-core";
import {
  DataGrid,
  useDataGrid,
  GridColumns,
  GridActionsCellItem,
  List,
  Stack,
  Avatar,
  Typography,
  Grid,
  Card,
  Button,
  useAutocomplete,
  Autocomplete,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Pagination,
} from "@pankod/refine-mui";
import { Edit, Close } from "@mui/icons-material";
// import { Lessons } from "../../../const/lessons";
import { Lessons } from "../../../const/lessons2";
import { IPrincipal, ISchool, IStudent, ITeacher } from "interfaces";
import moment from "moment";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { ChartJSOrUndefined } from "react-chartjs-2/dist/types";
import { exportAsPdf } from "utils/utils";
import { ExportAs } from "components/export";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

// {
//     <Grid item xs={2} sm={4} md={4} key={index}>
//         <ReportCard index={index} onClick={(sc)=>{
//             push(`${showUrl("lessonReport", index+1)}?school=${sc?.id}`)
//         }}/>
//     </Grid>
// ))}
const labels = Array.from(Array(21)).map((_, index) => `Lesson ${index + 1}`); //['January', 'February', 'March', 'April', 'May', 'June', 'July'];

function genColor(seed: number) {
  return `hsl(${(seed * 72) % 360}, 95%, 35%)`;
}

export const ClassReportShow: React.FC<IResourceComponentsProps> = () => {
  const { show, create, showUrl, push } = useNavigation();
  const t = useTranslate();
  const { mutate: mutateDelete } = useDelete();
  const { data: canShowTeacher } = useCan({
    action: "list",
    resource: "teacher",
  });

  const {
    queryResult: { data: studentDataL },
  } = useShow();
  console.log('stttttttuuuudennnnt data');
  console.log(studentDataL);
  const [studentData, setStudentData] = useState<{
    data: { students: any[] | undefined } | null;
  }>({
    data: null,
  });
  const chart = useRef<ChartJSOrUndefined<"bar">>();
  const [teacher, setTeacher] = useState<ITeacher | null>(null);
  const [sortingOrder, setSortingOrder] = useState("az");
  const [page, setPage] = useState(1);

  function getStudData() {
    return {
      data: {
        students: studentDataL?.data?.students
          .sort((a: any, b: any) => {
            return (
              (sortingOrder === "az" ? 1 : -1) *
              a.firstName.localeCompare(b.firstName)
            );
          })
          .slice((page - 1) * 30, page * 30),
      },
    };
  }

  useEffect(() => {
    if (studentDataL?.data) {
      setTeacher(studentDataL?.data?.teacher as ITeacher);
      setStudentData(getStudData());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentDataL?.data, sortingOrder, page]);

  const { autocompleteProps } = useAutocomplete<ITeacher>({
    resource: "teacher",
  });
console.log('studentDataaaaaaaaaaaaaaaaaaaaaaaaaaaa');
console.log(getStudData());
console.log(studentData);
console.log(page);
console.log(sortingOrder);
  return (
    <Grid
      container
      padding={4}
      gap={5}
      spacing={{ xs: 2, md: 3 }}
      columns={{ xs: 4, sm: 8, md: 12 }}
    >
      <Card
        style={{
          padding: 20,
          alignSelf: "flex-start",
          display: "flex",
          flexDirection: "column",
          gap: 20,
        }}
      >
        <Typography variant={"h6"} sx={{ margin: 0, fontWeight: "bold" }}>
          Fluency Class Progress Reports
        </Typography>

        {canShowTeacher?.can ? (
          <Autocomplete
            size="small"
            {...autocompleteProps}
            value={teacher}
            onChange={(_, value) => {
              setTeacher(value);
            }}
            getOptionLabel={(item) => {
              return `${item.lastName}, ${item.firstName} (${item.school?.name})`;
            }}
            isOptionEqualToValue={(option, value) =>
              value === undefined || option.id === value.id
            }
            style={{ width: 300 }}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" required />
            )}
          />
        ) : (
          <>
            <div style={{ width: 300 }} />
          </>
        )}
        <div style={{ alignSelf: "flex-end" }}>
          {canShowTeacher?.can && (
            <Button
              style={{ alignSelf: "flex-end" }}
              onClick={() => {
                if (teacher?.id) {
                  push(`${showUrl("teacher", teacher?.id)}`);
                }
              }}
            >
              Open
            </Button>
          )}

          <Button
            style={{ alignSelf: "flex-end" }}
            onClick={() => {
              if (teacher?.id || !canShowTeacher?.can) {
                push(`${showUrl("classReport", teacher?.id || "me")}`);
              }
            }}
          >
            Generate
          </Button>
        </div>
      </Card>
      <Card sx={{ flex: 1, padding: 2 }}>
        <Stack direction="row" justifyContent="space-between">
          <Typography
            style={{ cursor: "pointer" }}
            onClick={() => {
              if (sortingOrder === "az") {
                setSortingOrder("za");
              } else {
                setSortingOrder("az");
              }
            }}
            variant={"h6"}
          >
            {sortingOrder === "az" ? "A-Z ↓" : "A-Z ↑"}
          </Typography>
          <ExportAs
            id="graph"
            getExportName={() =>
              `${teacher?.lastName}, ${teacher?.firstName} (${teacher?.school?.name}) Report`
            }
            getRows={() => {
              const students = studentDataL?.data?.students.sort(
                (a: any, b: any) => {
                  return (
                    (sortingOrder === "az" ? 1 : -1) *
                    a.firstName.localeCompare(b.firstName)
                  );
                }
              );
              
              return [
                ["Student", "Progress"],
                //@ts-ignore
                ...students.map((student: any) => [
                  `${student?.firstName} ${student?.lastName}`,
                  student?.last_lesson
                    ? `L${student?.last_lesson}`
                    : "Not Started",
                ]),
              ];
            }}
          />
        </Stack>
        <div id="graph" className="px-4">
          <Typography variant={"h6"} sx={{ margin: 0, fontWeight: "bold" }}>
            Teacher: {teacher?.firstName} {teacher?.lastName} (
            {teacher?.school?.name})
          </Typography>
          <Bar
            //@ts-ignore
            ref={chart}
            onClick={function (e) {
              var xLabel = chart.current!!.scales["y"].getValueForPixel(
                e.nativeEvent.offsetY
              )!!;
              const student = studentData?.data?.students![xLabel]!!;
              push(showUrl("studentReport", student!!.id!!));
            }}
            height={250}
            options={{
              responsive: true,
              plugins: {
                legend: {
                  position: "top" as const,
                },
                title: {
                  display: true,
                  text: "Fluency Class Progress Report",
                },
                decimation: {
                  enabled: false,
                },
              },
              indexAxis: "y",
              scales: {
                x: {
                  type: "category",

                  min: 0,
                  max: 28,
                  labels: Array.from(Array(28)).map((_, i) => `L${i + 1}`),
                  position: "top",
                },
              },
            }}
            data={{
              labels: studentData?.data?.students!.map(
                (stud: any) => `${stud.firstName} ${stud.lastName}`
              ),

              datasets: [
                {
                  label: `Progress`,
                  data: studentData?.data?.students!.map((student: any) =>
                    student?.last_lesson ? `L${student?.last_lesson}` : null
                  ),
                  backgroundColor: "green",
                  //grouped: true,
                  barThickness: 10,
                },
              ],
            }}
          />
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Pagination
            count={Math.ceil((studentDataL?.data?.students.length ?? 1) / 30)}
            onChange={(e, value) => {
              setPage(value);
            }}
          />
        </div>
      </Card>
    </Grid>
  );
};
